module.exports = __webpack_public_path__ + "../static/img/kairos_mini.1354bb4f.png";